import { Component, Inject, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import {FormBuilder, Validators, FormGroup, ReactiveFormsModule} from "@angular/forms";
import { RegisterService } from "../services/register.service";
import { DomSanitizer } from "@angular/platform-browser";
import { CustomDatePipe } from "../shared/custom.datepipe";
import { DeviceDetectorService } from "ngx-device-detector";
import { PLATFORM_ID } from "@angular/core";
import { environment } from "../environments/environment";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-smsunsub',
  templateUrl: './smsunsub.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  styleUrls: ['./smsunsub.component.css']
})
export class SmsunsubComponent implements OnInit {

private page = "";
private countryCode = "de";
newsletterImage = "";
stickImage = "";
deButton = "";
amcLogoImage = "";
fieldLabel;
fieldLabel2;
amcUnsubForm: FormGroup;
amcUnsubFormLabel: FormGroup;
translateData = [];
language = { key: ["de"] };
serviceId = "3";
medium = "sms";
private serviceLabel: string;
public check: boolean = false;

/**
* @brief getCurrentPage()
* @param -
* @return -
* @details function to get the current page
*/
public getCurrentPage() {
return this.page;
}

constructor(
private router: Router,
private formBuilder: FormBuilder,
private registerService: RegisterService,
private route: ActivatedRoute,
private sanitized: DomSanitizer,
@Inject(PLATFORM_ID) private _platformId: Object
) {
this.newsletterImage = environment.newsletterImage;
this.stickImage = environment.stickImage;
this.deButton = environment.amcLogoImage;
this.amcLogoImage = environment.amcLogoImage;
}

ngOnInit() {
this.route.paramMap.subscribe((params: ParamMap) => {
this.countryCode = params.get("lang");
});

if (this.countryCode == null) {
this.countryCode = "de";
}

this.serviceLabel = "unsub_sms";

//let ParamValue;
//if (this.route.snapshot.queryParams["nl"]) {
//ParamValue = this.route.snapshot.queryParams["nl"];
//} else if (this.route.snapshot.queryParams["service"]) {
//ParamValue = this.route.snapshot.queryParams["service"];
//}

//switch (ParamValue.toUpperCase()) {
//case "0":
//case "MS":
//this.serviceId = "0";
//this.medium = "marketing service";
//this.serviceLabel = "unsub";
//break;
//case "1":
//case "NL":
//this.serviceId = "1";
//this.medium = "newsletter";
//this.serviceLabel = "nl_unsub";
//break;
//case "2":
//case "IS":
//this.serviceId = "2";
//this.medium = "information service";
//this.serviceLabel = "unsub_is";
//break;
//default:
//this.serviceId = "-1";
//}

    this.loadTranslateDataFromDB(this.countryCode);

    /**
    * Definition of form fields for unsubscriber
    */
    this.amcUnsubForm = this.formBuilder.group({
      oo_classId: ["4"],
      mobilenumber: [
              "",
//      [Validators.required, Validators.pattern('^(?!(\\d)\\1+$)(?:\\(?\\+\\d{1,3}\\)?[- ]?|0)?\\d{10,14}$')],
        [
          Validators.required,
//           Validators.pattern("[0-9]*\\/*(\\+49)*[ ]*(\\([0-9]+\\))*([ ]*(-|–)*[ ]*[0-9]+)*")
           Validators.pattern("^(?:(?:\\+|00)[1-9]\\d{1,3}[- ]?|\\(\\+\\d{1,3}\\)[- ]?|\\+?\\d{2}[- ]?)?[1-9]\\d{7,10}$")
        ]
      ],
      nl: [this.serviceId],
      isNewsletter: [this.serviceId],
      medium: [this.medium],
      token: ["inactive"],
      submittedTime: [this.getCustomDate()],
      subscriberLanguage: [this.countryCode],
      browser: [this.getBrowserInfo()],
      campaignCode: [""],
      treatmentCode: [""],
      individualHash: [""],
      countryNumber: [this.countryCode],
      supplierId: ["98"],
      active: ["1"],
    });

/**
* Definition of form field-labels for frontend
*/
this.amcUnsubFormLabel = this.formBuilder.group({
nl_mobile: ["Mobiltelefon"],
nl_unsub_btn: ["Abmelden"],
nl_heading_sms: ["AMC SMS"],
unsub_sms: [
        "Sie möchten sich von den AMC SMS abmelden? Tragen Sie bitte Ihr Mobiltelefon ein:",
],
nl_success_unsub_sms: ["Sie haben sich erfolgreich von SMS abgemeldet"],
nl_continue: ["Zurück"],
nl_err: ["Bitte überprüfen Sie Ihre Eingabe"],
nl_err_btn: ["Bitte überprüfen Sie Ihre Eingabe"],
});
}

getFieldContent(field) {
return this.amcUnsubForm.get(field);
}

getServiceLabel() {
return this.getFieldLabel(this.serviceLabel);
}

    getFieldLabel(Label) {
      if (Label == "nl_unsub_btn" && this.serviceId == "3") {
      Label = "nl_unsub_btn";
      }

      this.fieldLabel2 = this.amcUnsubFormLabel.get(Label);
      return this.fieldLabel2 != null ? this.fieldLabel2.value : "";
    }

  getBrowserInfo() {
      let deviceService = new DeviceDetectorService(this._platformId);
      return deviceService.browser + " V(" + deviceService.browser_version + ")";
    }

/**
* Get translated data from the database from register.service.ts
* @param language
*/
loadTranslateDataFromDB(language) {
this.translateData = [];
this.language.key = language;
this.registerService.loadTranslateDataFromDB(this.language.key).subscribe(
(data) => {
this.translateData = data;
this.setTranslate();
if (this.serviceId == "-1") {
this.router.navigate(["./" + this.countryCode + "/error/nms"]);
}
},
(error) => {
this.router.navigate(["./" + this.countryCode + "/error/nms"]);
}
);
}

    /**
    * Set labels with translated texts from the database
    */
    setTranslate() {
      this.translateData.forEach((obj) => {
      this.fieldLabel = this.translateData.find((k) => k.key === obj.key);
      if (
        this.fieldLabel != null &&
        this.amcUnsubFormLabel.get(obj.key) != null
      ) {
        this.amcUnsubFormLabel.controls[obj.key].setValue(this.fieldLabel.text);
      }
      });
    }

    /**
    * Submit unsubscription data to backend
    */
    onSubmitUnsub() {
      if (this.amcUnsubForm.valid) {
        this.registerService.unsubscribe(this.amcUnsubForm.value).subscribe(
          (response) => {
            if (response["response"] == "unsubsuccess") {
              this.router.navigate(["./" + this.countryCode + "/successunsubsms"]);
            } else {
              this.router.navigate(["./" + this.countryCode + "/error/nms"]);
            }
        },
        (error) => {
          this.router.navigate(["./" + this.countryCode + "/error/nms"]);
        }
      );
    }
}

/**
* get custom date format for database
*/
getCustomDate(dateFormat?: any) {
let customDatePipe = new CustomDatePipe("en-US");
return customDatePipe.transform(new Date(), dateFormat);
}
}

